export default __webpack_public_path__ + "static/media/MONT-BLANC-BOLD.a2fa921f.OTF";